import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

@Component({
  selector: 'flo-list-image',
  styleUrls: ['./list-image.component.scss'],
  templateUrl: './list-image.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ListImageComponent {
  @Input() public imageUrl: string
  @Input() public title: string
}
